export default {"src":"/_next/static/media/wbtc.af4989c4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};